import Tooltip from '@mui/material/Tooltip';
import { ReactNode } from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface ITooltipComponentProps {
  title: string | ReactNode;
  placement?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-start'
    | 'bottom-start'
    | 'left-start'
    | 'right-start'
    | 'top-end'
    | 'bottom-end'
    | 'left-end'
    | 'right-end';
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const TooltipComponent = ({
  title,
  children,
  placement,
  ...props
}: ITooltipComponentProps) => {
  return (
    <Tooltip
      {...props}
      title={title}
      placement={placement}
      sx={{ height: '100%' }}
      slotProps={{
        tooltip: {
          style: {
            backgroundColor: '#1A2035',
            color: '#fff',
            borderRadius: '4px',
            border: 'solid 0.5px gray',
            fontSize: '12px',
          },
        },
      }}
    >
      <span>{children}</span>
    </Tooltip>
  );
};

export default TooltipComponent;
